import React, { useEffect } from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';

const GoogleAnalytics = ({ measurementId }) => {
  const { isAllowed } = useCookieConsent();
  
  useEffect(() => {
    // Only initialize Google Analytics if analytics cookies are allowed
    if (isAllowed('analytics') && measurementId) {
      // Create script elements for Google Analytics
      const createGAScripts = () => {
        // Add the Google Analytics script tag
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(gaScript);
        
        // Initialize Google Analytics
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', measurementId, {
          anonymize_ip: true,
          cookie_flags: 'SameSite=None;Secure'
        });
        
        // Attach gtag to window
        window.gtag = gtag;
      };
      
      // Check if Google Analytics is already initialized
      if (!window.gtag) {
        createGAScripts();
      }
      
      // Cleanup function
      return () => {
        // If we need to remove GA when consent is withdrawn
        // This won't fully unload Google Analytics, but will prevent further tracking
        if (window.gtag) {
          window.gtag('config', measurementId, {
            send_page_view: false
          });
        }
      };
    }
  }, [isAllowed, measurementId]);
  
  return null; // This component doesn't render anything
};

const Analytics = () => {
  const { isAllowed } = useCookieConsent();
  
  // Track page views
  useEffect(() => {
    // Only track if analytics cookies are allowed
    if (isAllowed('analytics') && window.gtag) {
      // Track page view
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllowed, window.location.pathname]);
  
  return (
    <>
      {/* Add Google Analytics component with your measurement ID */}
      <GoogleAnalytics measurementId="G-XXXXXXXXXX" />
      
      {/* You can add other analytics providers here */}
    </>
  );
};

export default Analytics;
